(function(){
  if(!window.Shopify) return;
  Shopify.onError = function(XMLHttpRequest, textStatus){
    var data;
    try{
      data = JSON.parse(XMLHttpRequest.responseText);
    }catch(parseErr){
      try{ data = eval("("+XMLHttpRequest.responseText+")"); }catch(e){ data = { message: "Unexpected error", status: XMLHttpRequest.status, description: XMLHttpRequest.statusText }; }
    }
    if(data && data.message){
      alert(data.message+" ("+data.status+"): "+data.description);
    }else{
      alert("Error : "+Shopify.fullMessagesFromErrors(data).join("; "));
    }
  };
})();
